<template>
  <div class="view pa24">
    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="auto">
      <el-row>
        <el-col :xl="10">
          <el-form-item :label="$t('marketing', 'activityDuration')" prop="pickerValue">
            <el-date-picker
              v-model="ruleForm.pickerValue"
              value-format="yyyy-MM-dd"
              align="right"
              type="daterange"
              :start-placeholder="$t('marketing', 'startDate')"
              :end-placeholder="$t('marketing', 'endDate')"
              :picker-options="pickerOptions"
            />
          </el-form-item>
        </el-col>
        <el-col :xl="12">
          <el-form-item :label="$t('marketing', 'maxCreateGroupsPerAccount')">
            <el-input-number v-model="ruleForm.createLimit" :min="1" />
          </el-form-item>
        </el-col>
        <el-col :xl="10">
          <el-form-item :label="$t('marketing', 'groupSize')" prop="peopleNum">
            <el-input
              v-model="ruleForm.peopleNum"
              :min="2"
              @change="() => {
                ruleForm.peopleNum =  ruleForm.peopleNum < 2 ? 2 : ruleForm.peopleNum.replace(/\D/g,'')
              }"
              class="w120"
              :placeholder="$t('marketing', 'pleaseEnterPeopleCount')"
              type="number"
            />
            {{ $t('marketing', 'groupSizeGreaterThanOne') }}
          </el-form-item>
        </el-col>
        <el-col :xl="12">
          <el-form-item :label="$t('marketing', 'maxPurchasePerAccount')">
            <el-input-number v-model="ruleForm.maxPurchase" :min="1" />
          </el-form-item>
        </el-col>
        <el-col :xl="10">
          <el-form-item :label="$t('marketing', 'groupValidityHours')" prop="termOfValidity">
            <el-input
              v-model="ruleForm.termOfValidity"
              min="0"
              max="24"
              class="w120"
              :placeholder="$t('marketing', 'pleaseEnterHours')"
              type="number"
            />
          </el-form-item>
        </el-col>
        <el-col :xl="12">
          <el-form-item :label="$t('marketing', 'maxJoinGroupsPerAccount')">
            <el-input-number v-model="ruleForm.joinLimit" :min="1" />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div style="color: #ff5c6c">
      {{ $t('marketing', 'noteFillStock') }}
    </div>
    <div class="mt20" v-if="isDrafts">
      {{ $t('marketing', 'addGroupProduct') }}
      <el-button @click="centerDialogVisible = true"  class="ml10" type="primary"
        >{{ $t('marketing', 'addProduct') }}</el-button
      >
    </div>
    <commonTable :tableData="tableData" :total="tableData.length" :paginationVisible='false'>
      <template v-slot:table>
        <el-table-column
          prop="goodsId"
          align="center"
          :label="$t('marketing', 'productId')"
          show-overflow-tooltip
        />
        <el-table-column prop="goodsName" align="center" :label="$t('marketing', 'product')" />
        <el-table-column prop="goodsTypeName" align="center" :label="$t('marketing', 'category')" />
        <el-table-column prop="price" align="center" :label="$t('marketing', 'price')">
          <template slot-scope="scope">
            {{
              (scope.row[$route.query.id ? "minPrice" : "price"] / 100).toFixed(
                2
              )
            }}
          </template>
        </el-table-column>
        <el-table-column prop="stockNum" align="center" :label="$t('marketing', 'stock')" />
        <el-table-column
          :prop="$route.query.id ? 'totalBuyNum' : 'dealNum'"
          align="center"
          :label="$t('marketing', 'totalSales')"
        />
        <el-table-column prop="createTime" align="center" :label="$t('marketing', 'publishTime')">
          <template slot-scope="scope">
            {{ setGetDataTimeSec(scope.row.createTime) }}
          </template>
        </el-table-column>
      </template>
    </commonTable>
    <p class="">{{ $t('marketing', 'selectProductSpec') }}</p>
    <commonTable :tableData="specList" :total="specList.length">
      <template v-slot:table>
        <el-table-column
          prop="goodsName"
          align="center"
          :label="$t('marketing', 'productName')"
          show-overflow-tooltip
        />
        <el-table-column prop="typeName" align="center" :label="$t('marketing', 'productType')" />
        <el-table-column align="center" prop="specAttribute" :label="$t('marketing', 'productSpec')" />
        <el-table-column prop="stockNum" align="center" :label="$t('marketing', 'productStock')" />
        <el-table-column prop="price" align="center" :label="$t('marketing', 'price')">
          <template slot-scope="scope">
            {{ (scope.row.price / 100).toFixed(2) }}
          </template>
        </el-table-column>
        <el-table-column align="center" :label="$t('marketing', 'operation')" width="500">
          <template slot-scope="scope">
            {{ $t('marketing', 'groupAmount') }}
            <el-input
              class="d-inline-block w100"
              v-model="setSpec[scope.$index].assemblePrice"
              @change="() => {
                setSpec[scope.$index].assemblePrice =  setSpec[scope.$index].assemblePrice < 0.01 ? 0.01 : setSpec[scope.$index].assemblePrice
              }"
            />
            {{ $t('marketing', 'yuan') }} {{ $t('marketing', 'activityStock') }}
            <el-input
              class="d-inline-block w100"
              v-model="setSpec[scope.$index].assembleNum"
              @change="() => {
                setSpec[scope.$index].assembleNum =  setSpec[scope.$index].assembleNum < 1 ? 1 : setSpec[scope.$index].assembleNum.replace(/\D/g,'')
              }"
            />
          </template>
        </el-table-column>
      </template>
    </commonTable>
    <el-dialog
      :title="$t('marketing', 'selectProduct')"
      :visible.sync="centerDialogVisible"
      :modal-append-to-body="false"
      :destroy-on-close="true"
      width="60%"
      center
    >
      <product v-if="centerDialogVisible" ref="product" />
      <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible = false">{{ $t('marketing', 'cancel') }}</el-button>
        <el-button type="primary" @click="determine">{{ $t('marketing', 'confirm') }}</el-button>
      </span>
    </el-dialog>
    <div
      class="mt20 d-flex justify-content-center"
      v-if="$route.query.id ? false : true"
    >
      <el-button @click="save(0)" type="primary">{{ $t('marketing', 'saveToDrafts') }}</el-button>
      <el-button @click="save(1)">{{ $t('marketing', 'publish') }}</el-button>
    </div>
    <div class="mt20 d-flex justify-content-center" v-else>
      <el-button type="primary" @click="save(draftType)">{{ $t('marketing', 'saveEdit') }}</el-button>
    </div>
  </div>
</template>

<script>
import commonTable from "@/components/common/commonTable";
import product from "@/pages/marketingActivities/spike/components/product";
import { getDataTimeSec } from "@/utils";
import { insertGoodsAssemble, updateGoodsAssembleInfo } from "@/api/joinGroup";
import i18nMixin from '@/mixins/i18nMixin';

export default {
  mixins: [i18nMixin],
  data() {
    return {
      tableData: [],
      specList: [],
      setSpec: [],
      ruleForm: {
        pickerValue: "",
        createLimit: "",
        peopleNum: "",
        maxPurchase: "",
        termOfValidity: 24,
        joinLimit: "",
      },
       pickerOptions: {
        disabledDate(time) {
          return time.getTime() <= Date.now() - 24 * 60 * 60 * 1000;
        },
      },
      centerDialogVisible: false,
      draftType: "",
      isDrafts:''
    };
  },
  computed: {
    setGetDataTimeSec() {
      return (val) => getDataTimeSec(val);
    },
    // 将rules移到computed中，确保可以访问this.$t
    rules() {
      return {
        pickerValue: [{ required: true, message: this.$t('marketing', 'pleaseSelectActivityDuration') }],
        peopleNum: [{ required: true, message: this.$t('marketing', 'pleaseEnterGroupSize') }],
        termOfValidity: [{ required: true, message: this.$t('marketing', 'pleaseEnterGroupValidity') }],
      };
    },
  },
  components: {
    commonTable,
    product,
  },
  created() {
    this.isDrafts = this.$route.query.drafts== '1' ? false : true
    const { id } = this.$route.query;
    if (id) {
      this.updateGoodsAssembleInfo(id);
    }
    
    // 监听语言变化，强制更新组件
    this.$root.$on('language-changed', () => {
      this.$forceUpdate();
    });
  },
  beforeDestroy() {
    // 清理事件监听
    this.$root.$off('language-changed');
  },
  methods: {
    determine() {
      const { multipleSelection } = this.$refs.product;
      const arr = [];
      this.setSpec = [];
      this.tableData = [multipleSelection];
      for (let i = 0; i < multipleSelection.goodSpecModelList.length; i++) {
        let type = multipleSelection.goodSpecModelList[i];
        for (let j = 0; j < type.goodSpecModelList.length; j++) {
          let spec = type.goodSpecModelList[j];
          spec.goodsName = multipleSelection.goodsName;
          spec.typeName = type.specName;
          spec.stockNum = multipleSelection.stockNum;
          this.setSpec.push({
            assemblePrice: "",
            assembleNum: "",
            stockNum: spec.stockNum,
            price: spec.price,
            specId: spec.specId,
          });
          arr.push(spec);
        }
      }
      this.specList = arr;
      this.centerDialogVisible = false;
    },
    /**@method  发布*/
    save(type) {
      if (this.tableData.length == 0) {
        this.$message({
          message: this.$t('marketing', 'pleaseSelectProductFirst'),
          type: "warning",
        });
        return;
      }
      const checkPrice = this.setSpec.find((item) => item.assemblePrice <= 0);
      if (checkPrice) {
        this.$message({
          message: this.$t('marketing', 'groupAmountCannotBeLessThanZero'),
          type: "warning",
        });
        return;
      }
      console.log(this.setSpec);
      for (let i = 0; i < this.setSpec.length; i++) {
        if (!this.setSpec[i].assemblePrice || !this.setSpec[i].assembleNum) {
          this.$message({
            message: this.$t('marketing', 'groupAmountAndStockCannotBeEmpty'),
            type: "warning",
          });
          return;
        }
        if (this.setSpec[i].assemblePrice * 100 > this.setSpec[i].price) {
          this.$message({
            message: this.$t('marketing', 'groupAmountCannotExceedProductPrice'),
            type: "warning",
          });
          return;
        }
        if (this.setSpec[i].assembleNum > this.setSpec[i].stockNum) {
          this.$message({
            message: this.$t('marketing', 'groupQuantityCannotExceedTotalStock'),
            type: "warning",
          });
          return;
        }
      }
      let temp = this.setSpec.map((item) => {
        return {
          specId: item.specId,
          assemblePrice: item.assemblePrice * 100,
          assembleNum: item.assembleNum,
        };
      });
      this.$refs.ruleForm.validate(async (valid) => {
        if (valid) {
          
          try {
            let data = {
              assembleId: this.tableData[0].assembleId,
              assembleType: type,
              goodSpecRequestList: temp,
              goodsId: this.tableData[0].goodsId,
              startTimes: `${this.ruleForm.pickerValue[0]} 00:00:00`,
              endTimes: `${this.ruleForm.pickerValue[1]} 23:59:59`,
              updateType: this.$route.query?.drafts == "1" ? 0 : 1,
              peopleNum: this.ruleForm.peopleNum,
              openRegiment: this.ruleForm.createLimit,
              joinRegiment: this.ruleForm.joinLimit,
              maxPurchase: this.ruleForm.maxPurchase,
            };
            console.log(data)
           await insertGoodsAssemble(data);
            this.$message({
              message: type == 1 ? this.$t('marketing', 'publishSuccess') : this.$t('marketing', 'saveSuccess'),
              type: "success",
            });
            setTimeout(() => {
              this.$router.go(-1);
            }, 1000);
          } catch (error) {
            this.$message.error(type == 1 ? error.message || this.$t('marketing', 'publishFailed') : error.message || this.$t('marketing', 'saveFailed'));
            console.log();
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    /**@method 获取编辑内容 */
    async updateGoodsAssembleInfo(id) {
      const result = await updateGoodsAssembleInfo(
        { assembleId: id },
        { showLoading: true }
      );
      const {
        startTime,
        endTime,
        peopleNum,
        openRegiment,
        maxPurchase,
        joinRegiment,
        assembleType,
        goodSpecModelList,
        goodsName,
        stockNum
      } = result.data;
      this.ruleForm.pickerValue = [
        this.setGetDataTimeSec(startTime),
        this.setGetDataTimeSec(endTime),
      ];
      this.ruleForm.peopleNum = peopleNum;
      this.ruleForm.termOfValidity = result.data.termOfValidity || 24;
      this.ruleForm.createLimit = openRegiment;
      this.ruleForm.maxPurchase = maxPurchase;
      this.ruleForm.joinLimit = joinRegiment;
      this.tableData = [result.data];
      this.draftType = assembleType;
      const arr = [];
      this.setSpec = [];
      for (let i = 0; i < goodSpecModelList.length; i++) {
        let type = goodSpecModelList[i];
        for (let j = 0; j < type.goodSpecModelList.length; j++) {
          let spec = type.goodSpecModelList[j];
          spec.goodsName = goodsName;
          spec.typeName = type.specName;
          spec.stockNum = stockNum;
          this.setSpec.push({
            assemblePrice: spec.assemblePrice / 100,
            assembleNum: spec.assembleNum,
            stockNum: spec.stockNum,
            price: spec.price,
            specId: spec.specId,
          });
          arr.push(spec);
        }
      }
      this.specList = arr;
      console.log(result);
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
